module.exports = __webpack_public_path__ + "static/media/machine.74bbab1a.png";